























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserFilter, LeaveTypeFilter } from './EventFiltersParts';
import { User } from '@/types/user';

@Component({
  components: {
    UserFilter,
    LeaveTypeFilter,
  },
})
export default class EventFilters extends Vue {
  private drawer = false;

}
